.RACollapsibleContainer
    width: 100%
    min-height: 40px
    height: 40px
    display: flex
    flex-direction: column
    justify-content: flex-start
    flex-shrink: 0
    flex-basis: 40px
    border-bottom: 1px solid rgb($globalSettingsStrokePrimary)
    overflow: hidden
    background-color: rgb($globalSettingsBackgroundPrimary)
    .RACollapsibleRow
        position: relative
        width: 100%
        height: 40px
        display: flex
        align-items: center
        cursor: pointer
        opacity: 1
        flex-shrink: 0
        overflow: hidden
    .RACollapsibleRowHidden
        height: 0
        opacity: 0
    .RAContent
        width: 100%
        height: 0
        min-height: 0
        overflow: hidden
    .RAContentExpanded
        height: unset
        flex-grow: 1
        overflow-x: hidden
        overflow-y: auto
    .RAArrowWrapper
        position: absolute
        right: 20px
        top: 50%
        transform: translateY(-50%)
        stroke: rgb($globalSettingsFontPrimary)
        z-index: 5
.RACollapsibleClean
    border-bottom: none
.RACollapsibleOpened
    height: unset
    flex-grow: 1
    .RAArrow
        transform: rotateZ(180deg)